import axios from "axios";

export default {
  name: "AddressCodedUncoded",
  props: {
    dataObj: {
      require: true,
      type: Object,
    },
  },
  data: function () {
    return {
      addressesLabels: { coded: [], uncoded: [] },
      isLoading: true,
    };
  },
  created() {
    this.getLablels();
  },
  methods: {
    getLablels() {
      this.isLoading = true;

      axios
        .post("/EmployeeApplication/GetCustomAddressLines")
        .then((resp) => {
          this.addressesLabels.coded =
            resp.data.items.customerCodedAddressLineNames;
          this.addressesLabels.uncoded =
            resp.data.items.customerUncodedAddressLineNames;
        })
        .catch((err) => this.$alertMsg(err.data.data.text))
        .finally(() => (this.isLoading = false));
    },
    showInGoogleMap() {
      var address = "";

      if (this.dataObj.postalData.addressType === 1) {
        if (this.dataObj.postalData.postalAddress)
          address = this.dataObj.postalData.postalAddress;

        if (this.dataObj.postalData.ownerAddress)
          address = address
            ? `${address},${this.dataObj.postalData.ownerAddress}`
            : this.dataObj.postalData.ownerAddress;

        if (this.dataObj.postalData.contact)
          address = address
            ? `${address},${this.dataObj.postalData.contact}`
            : this.dataObj.postalData.contact;

        if (this.dataObj.postalData.ownerFullName)
          address = address
            ? `${address},${this.dataObj.postalData.ownerFullName}`
            : this.dataObj.postalData.ownerFullName;

        if (this.dataObj.postalData.buildingName)
          address = address
            ? `${address},${this.dataObj.postalData.buildingName}`
            : this.dataObj.postalData.buildingName;
      } else if (this.dataObj.postalData.addressType === 0) {
        if (this.dataObj.postalData.code)
          address = address
            ? `${address},${this.dataObj.postalData.code}`
            : this.dataObj.postalData.code;

        if (this.dataObj.postalData.careOf)
          address = address
            ? `${address},${this.dataObj.postalData.careOf}`
            : this.dataObj.postalData.careOf;

        if (this.dataObj.postalData.houseNumber)
          address = address
            ? `${address},${this.dataObj.postalData.houseNumber}`
            : this.dataObj.postalData.houseNumber;

        if (this.dataObj.postalData.flatName)
          address = address
            ? `${address},${this.dataObj.postalData.flatName}`
            : this.dataObj.postalData.flatName;

        if (this.dataObj.postalData.flatNumber)
          address = address
            ? `${address},${this.dataObj.postalData.flatNumber}`
            : this.dataObj.postalData.flatNumber;

        if (this.dataObj.postalData.buildingName)
          address = address
            ? `${address},${this.dataObj.postalData.buildingName}`
            : this.dataObj.postalData.buildingName;
      }

      let gmapsUrl =
        "https://www.google.com/maps?q=" + this.encodeForGoogleMaps(address);

      window.open(gmapsUrl);
    },
    encodeForGoogleMaps(addr) {
      return addr.replaceAll(/ /g, "+");
    },
  },
};
